<script setup lang="ts">
import PageNotFoundEmptyState from '@/components/emptyStates/PageNotFoundEmptyState.vue';
</script>

<template>
  <div :class="$style.errorPageView" data-testid="errorPageView">
    <PageNotFoundEmptyState />
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.errorPageView {
  padding: 120px 0 0 0;
}
</style>
